import { Component, OnInit,Input,Pipe, PipeTransform  } from '@angular/core';

@Component({
  selector: 'app-miners',
  templateUrl: './miners.component.html',
  styleUrls: ['./miners.component.scss']
})

export class MinersComponent implements OnInit {
  @Input()  miners;
  @Input()  mobileMining;
  @Input()  Mobileminers;

  constructor() {
  }

  ngOnInit() {

  }

    objectKeys(obj) {

      return Object.keys(obj);
    }
}



// WEBPACK FOOTER //
// ./src/app/miners/miners.component.ts